import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@dotcom/crown-ui';
import { AuthenticatedFormProps } from '../save-project-dialog-types';
import { useProjectNameValidation, PROJECT_NAME_MAX_LENGTH } from '../../../hooks/use-project-name-validation';
import styles from '../save-project-dialog.module.scss';

export const AuthenticatedForm = ({
  formMethods: {
    register,
    setValue,
    setError,
    formState: { errors },
  },
  onSubmit,
}: AuthenticatedFormProps) => {
  const { t } = useTranslation();

  const { handleNameChange, maxLengthMessage } = useProjectNameValidation({
    fieldName: 'projectName',
    setValue,
    setError,
  });

  return (
    <form className={styles.form} onSubmit={onSubmit}>
      <TextField
        register={register('projectName', {
          required: `${t('saveProjectDialog.requiredProjectName')}`,
          maxLength: {
            value: PROJECT_NAME_MAX_LENGTH,
            message: maxLengthMessage,
          },
          onChange: handleNameChange,
        })}
        domId="project_name"
        required
        label={`${t('saveProjectDialog.projectNameLabel')}`}
        className={styles['text-field']}
        isError={Boolean(errors.projectName)}
        helperText={errors.projectName?.message ?? ''}
      />
    </form>
  );
};
